<template>
	<div class="tab" data-name="jobTenureInfo" data-type="table">
		<h3>فرم سوابق شغلی</h3>
		<p>[ این فرم مربوط به سابقه کاری شما می باشد]</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td style="width:100px; ">ردیف</td>
					<td>نام موسسه</td>
					<td>ادرس و تلفن</td>
					<td colspan="2">تاریخ خدمت از ... تا</td>
					<td>سمت</td>
					<td>نام مافوق</td>
					<td>پایه حقوق</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>ردیف 1</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="institute" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="addPhone" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="from" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="until" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="side" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="boss" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="sallary" />
					</td>
				</tr>
				<tr>
					<td>ردیف 2</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="institute" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="addPhone" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="from" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="until" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="side" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="boss" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="sallary" />
					</td>
				</tr>
				<tr>
					<td>ردیف 3</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="institute" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="addPhone" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="from" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="until" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="side" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="boss" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="sallary" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},

		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		},
	};
</script>
